@if (isNavbarVisible) {
  <nav class="navbar navbar-expand-lg" acp-navbar></nav>
}

<!-- Class name 'content-container' is required for the UI design stylesheets to work -->
<div class="content-container">
  <router-outlet></router-outlet>
</div>

<div class="toasts-wrapper px-2" acp-toast-notification-host></div>
